export const CHAT_CONFIG_RULES = {
  maxImageSize: parseInt(
    process.env.REACT_APP_CHAT_MAX_AVATAR_SIZE ||
    process.env.REACT_APP_DEFAULT_MAX_AVATAR_SIZE ||
    "1"
  ),
};
